module.exports = __webpack_public_path__ + "static/streamlined-solutions-80f6155cf2908682c86e397d78c67b37.svg";